import React from "react";
import OfficeSelect from "../../design/OfficeSelect";


const InvoicesHead = React.memo(({data, setData, onClickSend}) => {

    return (
        <div className={"InvoicesListFilter"}>
            <p>משרד</p>

            <OfficeSelect 
            value={data.office} 
            setValue={(value) => setData({...data, office: value})} 
            />
            
            <p>תאריך התחלה</p>
            <input 
            type={"date"} 
            value={data.date_f} 
            onChange={(event) => setData({...data, date_f: event.target.value})} 
            />

            <p>תאריך סיום</p>
            <input 
            type={"date"} 
            value={data.date_e} 
            onChange={(event) => setData({...data, date_e: event.target.value})} 
            />

            <p>סוג תשלום</p>
            <select 
            value={data.type} 
            onChange={(event) => setData({...data, type: event.target.value})} 
            >
                <option value={"all"}> הכל </option>

                {
                    ["מזומן", "אשראי", "העברה", "צ'ק", "שובר"].map((value, key) => (
                        <option value={key}> {value} </option>
                    ))
                }

            </select>

            <p>סטטוס</p>

            <select value={data.status} onChange={(event) => setData({...data, status: event.target.value})}>
                <option value={"*"}> {"הכל"} </option>
                <option value={0}> {"ממתין לאישור"} </option>
                <option value={1}> {"אושר"} </option>
                <option value={2}> {"נפל"} </option>
            </select>

            <div onClick={onClickSend}>
                <p className={"InvoicesListFilterSend"}>שליחה</p>
            </div>

        </div>
    )
})


export default InvoicesHead;